import { render, staticRenderFns } from "./deepseek.vue?vue&type=template&id=2a883f7c&scoped=true"
import script from "./deepseek.vue?vue&type=script&lang=js"
export * from "./deepseek.vue?vue&type=script&lang=js"
import style0 from "./deepseek.vue?vue&type=style&index=0&id=2a883f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a883f7c",
  null
  
)

export default component.exports